import * as React from 'react';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { MenuUnfoldIcon } from '../../../custom_shared/icons';
import { ClickableIcon } from '../../../common/components';
import { DocumentPreviewStore } from '../../stores';
import { getIconSize } from '../../../documents/config/iconSizes';

interface Props {
    documentPreviewStore: DocumentPreviewStore;
    lightMode?: boolean;
}

const MinimapToggleButton: React.FC<Props> = ({ documentPreviewStore, lightMode }) => {
    const iconSize = getIconSize('previewControls', lightMode);

    return (
        <Tooltip title={`${documentPreviewStore.showMinimap ? 'Close' : 'Open'} minimap`} placement="topLeft">
            <ClickableIcon
                width={iconSize}
                height={iconSize}
                icon={MenuUnfoldIcon}
                onClick={() => documentPreviewStore.setShowMinimap(!documentPreviewStore.showMinimap)}
            />
        </Tooltip>
    );
};

export default observer(MinimapToggleButton);
